import tariffRecommenderImage from '../../../assets/images/tariffs-illustration-utilita.png';
import type { Images } from '../ThemeTypes';

const images: Images = {
  tariffRecommender: {
    mainCardLogo: tariffRecommenderImage,
    width: '100%',
    '${min.sm}': {
      width: '200px',
    },
  },
};

export default images;
